export default "__VITE_ASSET__50a7fd37__"